import { Text, StyleSheet } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

function SFRGeneralRecommendation({ recommendation }) {
  const { t } = useTranslation();
  // Define an array of the nutrients we want to display recommendations for
  const nutrients = ["ph", "soc", "nitrogen", "phosphorus", "potassium"];

  return (
    <>
      <Text style={styles.sectionTitle}>{t("soil.generalRecommendations")}</Text>
      {nutrients.map((nutrient) => {
        // Use variable as key "[nutrient]", go into the recommendation object and get the recommendation for this nutrient. e.g. recommendation.nitrogen.recommendation
        const recObj = recommendation?.[nutrient];

        // If recommendation exists, show it (translate at render time)
        if (recObj) {
          const text = recObj.recommendationKey
            ? t(recObj.recommendationKey, recObj.recommendationParams)
            : recObj.recommendation;

          return (
            <Text key={nutrient} style={styles.recommendationItem}>
              <Text style={styles.nutrientLabel}>
                {nutrient.charAt(0).toUpperCase() + nutrient.slice(1)}: {" "}
              </Text>
              {text}
            </Text>
          );
        }

        // If no recommendation, return nothing
        return null;
      })}
    </>
  );
}

export default SFRGeneralRecommendation;

const styles = StyleSheet.create({
  sectionTitle: {
    fontSize: 13,
    fontWeight: "bold",
    marginBottom: 8,
  },
  recommendationItem: {
    fontSize: 10,
    color: "#374151",
    marginBottom: 4,
    lineHeight: 1.5,
  },
  nutrientLabel: {
    fontWeight: "bold",
  },
});
